let mapsLoadPromise = null;

export default function loadGoogleMaps() {
    if (window.google?.maps?.Map) return Promise.resolve();
    if (mapsLoadPromise) return mapsLoadPromise;

    mapsLoadPromise = new Promise((resolve, reject) => {
        const waitForMaps = (startedAt = Date.now()) => {
            if (window.google?.maps?.Map) {
                resolve();
                return;
            }
            if (Date.now() - startedAt > 15000) {
                reject(new Error('Google Maps failed to load'));
                return;
            }
            setTimeout(() => waitForMaps(startedAt), 50);
        };

        if (document.querySelector('script[data-google-maps-sdk]')) {
            waitForMaps();
            return;
        }

        const callbackName = '__borderGoogleMapsReady';
        window[callbackName] = () => {
            delete window[callbackName];
            resolve();
        };

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&callback=${callbackName}`;
        script.async = true;
        script.defer = true;
        script.dataset.googleMapsSdk = 'true';
        script.onerror = () => reject(new Error('Failed to load Google Maps script'));
        document.head.appendChild(script);
    });

    return mapsLoadPromise;
}
